import { render, staticRenderFns } from "./AppStoreDiscoverSection.vue?vue&type=template&id=114ea95a&scoped=true"
import script from "./AppStoreDiscoverSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreDiscoverSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStoreDiscoverSection.vue?vue&type=style&index=0&id=114ea95a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ea95a",
  null
  
)

export default component.exports